'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import * as DataTypes from '../../../constants/dataTypes';
import { EQ } from '../../../constants/operators';
import inboundDb from './inboundDb';
import { ACCUMULATE } from '../../../constants/processorTypes';
import { buildDrilldownReport } from '../report';
const SENTIMENT_METRICS = ['passivesCount', 'promotersCount', 'detractorsCount'];
const convertFeedbackProperty = prop => ImmutableMap({
  surveyType: 'feedbackSubmission.formType',
  customerType: 'feedbackSubmission.responseGroup',
  score: 'feedbackSubmission.rating',
  d1: 'feedbackSubmission.surveyId',
  passives: 'PASSIVE',
  promoters: 'PROMOTER',
  detractors: 'DETRACTOR',
  passivesCount: 'PASSIVE',
  promotersCount: 'PROMOTER',
  detractorsCount: 'DETRACTOR',
  sessionDate: 'hs_timestamp'
}).get(prop, prop);
const getFeedbackDrilldown = (report, keys, options) => {
  let adjustedConfig = report.get('config').set('dataType', DataTypes.FEEDBACK);
  if (adjustedConfig.getIn(['metrics', 0, 'property']) === 'score') {
    adjustedConfig = adjustedConfig.update('processors', List(), procs => procs.push(ACCUMULATE));
  }

  // sentiment breakdown, fake pie chart
  if (keys.count() === 2) {
    adjustedConfig = adjustedConfig.updateIn(['filters', 'custom'], List(), filters => filters.push({
      property: 'customerType',
      operator: EQ,
      value: keys.first()
    }));
  }
  const adjustedReport = report.set('config', adjustedConfig);
  return inboundDb.generate(adjustedReport, keys).then(engConfig => {
    return engConfig.update('metrics', metrics => metrics.filterNot(metric => SENTIMENT_METRICS.includes(metric.get('property'))).map(metric => metric.update('property', convertFeedbackProperty))).updateIn(['filters', 'custom'], List(), customFilters => customFilters.filter(filter => filter.get('property') !== 'customerType').map(filter => {
      return filter.update('property', convertFeedbackProperty).update('value', convertFeedbackProperty);
    })).updateIn(['filters', 'dateRange', 'property'], convertFeedbackProperty);
  }).then(config => buildDrilldownReport(report, config, options));
};
export default {
  isSupported: report => {
    switch (report.getIn(['config', 'dataType'])) {
      case DataTypes.UNIFIED_FEEDBACK_EMAIL:
      case DataTypes.UNIFIED_FEEDBACK_TRENDS:
      case DataTypes.UNIFIED_FEEDBACK_WEB:
      case DataTypes.FEEDBACK:
        return true;
      default:
        return false;
    }
  },
  generate: getFeedbackDrilldown
};